import React from 'react';
import { useReadDashboardMessageMutation } from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	item: DashboardMessagesItemScheme;
}

export interface DashboardMessagesItemScheme {
	id: string;
	image?: string;
	subtitle?: string;
	title?: string;
	wizardKey: string;
	entityId?: string;
	notificationId?: string;
	conversationId?: string;
	icon?: string;
}

const DashboardMessagesItem: React.FC<Props> = ({
	item: {
		id,
		image,
		icon,
		subtitle,
		title,
		wizardKey,
		entityId,
		notificationId,
		conversationId,
	},
}) => {
	const { userData } = useAppContext();
	const [markAsRead] = useReadDashboardMessageMutation();

	const handleClick = async () => {
		if (conversationId) {
			await markAsRead({ input: { messageId: id, userId: userData.id } });
			// @ts-ignore
			window.location.href = `/centrum-akci/detail-zpravy/${conversationId}`;
		}
		if (entityId && wizardKey) {
			// @ts-ignore
			window.location.href = `/case-wizard/${wizardKey}?entityId=${entityId}`;
		}
		if (notificationId && wizardKey) {
			// @ts-ignore
			window.location.href = `/case-wizard/${wizardKey}?notificationId=${notificationId}`;
		}
	};

	return (
		<div
			className='button-list__btn'
			style={{ cursor: 'pointer' }}
			onClick={handleClick}
		>
			{image && (
				<img className='button-list__btn__icon' src={image} alt='icon' />
			)}
			{icon && (
				<div className='button-list__btn__icon-wrapper squared'>
					<i className={'fa-regular fa-' + icon}></i>
				</div>
			)}
			<div className='button-list__btn__content'>
				{subtitle && (
					<span className='button-list__btn__content__subtitle'>
						{subtitle}
					</span>
				)}
				{title && (
					<div className='button-list__btn__content__title'>{title}</div>
				)}
			</div>
			<div className='button-list__btn__arrow primary'>
				<i className='fa-solid fa-angle-right' aria-hidden='true'></i>
			</div>
		</div>
	);
};

export default DashboardMessagesItem;
